import { useQuery } from 'react-query';

import { getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId } from 'src/client/spendesk-api';
import { useCompany } from 'src/core/modules/app/hooks/useCompany';

import {
  type ApiBudgetDefinition,
  convertApiToBudgetDefinition,
} from './budgetDefinition';
import { getApiKey } from './keys';

export const useGetBudgetDefinition = (budgetDefinitionId: string) => {
  const company = useCompany();
  return useQuery(
    getApiKey([budgetDefinitionId]),
    async () => {
      const response =
        await getV2ApiCompanyIdBudgetDefinitionsBudgetDefinitionId({
          path: {
            companyId: company.id,
            budgetDefinitionId,
          },
        });

      if (response.statusCode !== 200) {
        throw new Error('Failed to get budget definitions');
      }
      return convertApiToBudgetDefinition(response.body as ApiBudgetDefinition);
    },
    {
      retry: false,
    },
  );
};
